



























import {Component, Prop, Vue} from "vue-property-decorator";
import * as Constants from "@/Constants";
import {Getter} from "vuex-class";
import {User} from "front-component/modules/User";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import { Notification } from "@/modules/Notification";
import Owner from "@/model/cospirit-api/Owner";
import {Type} from "@/modules/request/Type";
import _ from "lodash";
import Tag from "@/components/miscellaneous/Tag.vue";
import NotificationRepository from "@/repositories/NotificationRepository";

const components = {
    Tag,
    SelectOwner
};
@Component({components})
export default class SocleApprovalWorkflowEdit extends Vue {
    @Prop() private notificationData!: Notification;
    @Prop() private module!: string;

    private notification: Notification | null = null;
    private notificationChannels: { [channel: string]: string } = Constants.notificationChannels;
    private loadingNotification = false;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getCurrentUser") public user!: User;

    private mounted(): void {
        if (this.$route.params.uuid) {
            this.getNotification(this.$route.params.uuid);
        } else  {
            this.editNotification(null);
        }
    }

    private getNotification(uuid: string): void {
        this.loadingNotification = true;
        const params = {
            filters: {
                uuid
            },
        };
        NotificationRepository.get(params).then((data) => {
            const firstNotification = data[0] as Notification;
            this.editNotification(firstNotification);
            this.loadingNotification = false;
        }).catch(() => {
            this.loadingNotification = false;
        });
    }

    private editNotification(notification: Notification | null): void {
        this.notification = {
            uuid: _.get(notification, "uuid", null),
            triggers: _.get(notification, "triggers", []),
            channels: _.get(notification, "channels", []),
            owner: {
                uuid: this.ownerUuid,
            },
            hierarchyOwner: {
                uuid: _.get(notification, "hierarchyOwner.uuid", null),
            },
            module: _.get(notification, "module", this.module),
        };
    }

    private saveNotification(): void {
        this.loadingNotification = true;
        const saveNotification = _.cloneDeep(this.notification) as Notification;
        if (!saveNotification.uuid) {
            saveNotification.module = "socle_approval_workflow";
        }
        NotificationRepository.save(saveNotification).then(() => {
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "saveNotificationSuccess"),
                type: "success"
            });
            this.loadingNotification = false;
            this.$router.push({
                name: "notifications_socle_approval_workflow_list"
            });
        });
    }

    private get canSaveNotification(): boolean {
        return (!!this.notification &&
                !!this.notification.hierarchyOwner && !!this.notification.hierarchyOwner.uuid) &&
            (!!this.notification && 0 < this.notification.channels.length);
    }

    private cancelEditNotification(): void {
        this.$router.push({
            name: "notifications_socle_approval_workflow_list",
        });
    }
}
